import React from 'react';

import { GenerateListIcon } from './GenerateListIcon';
import { ListIconsProps } from './types';

const defaultTooltipMessageKey = 'layout.action.view';

export const ViewIcon: React.FC<ListIconsProps> = ({
  tooltipMessageKey = defaultTooltipMessageKey,
  enabled = true,
  ...rest
}) =>
  enabled ? (
    <GenerateListIcon {...rest} color="blue-light" kind="view" size={30} tooltipMessageKey={tooltipMessageKey} />
  ) : (
    <GenerateListIcon
      {...rest}
      additionalClassName="view-disabled"
      color="blue-light"
      kind="view"
      size={30}
      tooltipMessageKey={tooltipMessageKey !== defaultTooltipMessageKey ? tooltipMessageKey : undefined}
    />
  );
